import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ status, nextStatus }) =>
    present(
      repository.updateTaskStatus(status, nextStatus).catch(() =>
        Promise.reject({
          nextStatus,
          status,
        }),
      ),
    );
}

export type { Interactor };

export { createInteractor };
